const baseApiUrl = process.env.REACT_APP_API_URL;

export const fileTransferUrls = {
  getFolderIdByName: baseApiUrl + "Moveit/GetFolderIdByName_Rv3?",
  getFolderContent: baseApiUrl + "Moveit/GetFolderContent?",
  downloadFile: baseApiUrl + "Moveit/DownloadFile?",
  deleteFile: baseApiUrl + "Moveit/DeleteFile?",
  uploadFile: baseApiUrl + "Moveit/UploadFile",
  processFile: baseApiUrl + "Moveit/SaveFileToDatabase",
};
